




















































































































import Vue from 'vue';
import SelectEventBox from './SelectEventBox.vue';
import PrepareTimeBox from './PrepareTimeBox.vue';
import ScheduleMsgBox from './ScheduleMsg.vue';
import ScheduleMsgDisplay from './ScheduleMsgDisplay.vue';
import scheduleRuleVuex from '../../../vuex/common';
import { ScheduleRuleType } from '../../../models/ScheduleRule';
import {
  ScheduleMsg,
  WxTpl,
  transDiv,
  transValue,
} from '../../../models/ScheduleMsg';
import { EventTriggered } from '../../../models/ScheduleRuleContext';
import {
  ScheduleEventType,
  TraceEventType,
} from '../../../models/ScheduleEventParam';
import { ScheduleEventDelayType } from '../../../models/ScheduleRuleContext';
import {
  ScheduleDelayUnit,
  ScheduleDelay,
  showFixedDelay,
  DelayMode,
} from '../../../models/ScheduleDelay';
import ruleClient from '../../../apis';
import  {  ScheduleMsgDisplayInfo } from '@/rule/models/ScheduleMsg';

function dripProp(name: string): string {
  return `<drip-prop contenteditable="false">#${name}</drip-prop>`;
}

export default Vue.extend({
  mixins: [scheduleRuleVuex],
  components: {
    SelectEventBox,
    PrepareTimeBox,
    ScheduleMsgBox,
    ScheduleMsgDisplay,
  },
  data() {
    return {
      showSelectEvent: false,
      showPrepareTime: false,
      showSelectTargetPage: false,
      showScheduleMsg: false,
      creating: false,
      ScheduleEventType,
      ScheduleDelayUnit,
      ScheduleEventDelayType,
      showFixedDelay,
      info: {} as (ScheduleMsgDisplayInfo),
    };
  },
  computed: {
    tranProps(): any[] {
      const temp = JSON.parse(JSON.stringify(this.props));
      return temp.map((p: any) => {
        p.propName = dripProp(p.propName)
        return p;
      });
    },
  },
  mounted() {
    const dm = this.initDelayMode();
    if(dm) {
      this.$store.commit('UPDATE_EVENT_DELAY_MODE', dm);
    }
  },
  methods: {
    initTimeBox(): void {
      this.$nextTick(() => {
        if(this.$refs.prepareTimeBoxRef) {
          (this.$refs.prepareTimeBoxRef as any).initTab();
        }
      })
    },
    initDelayMode(): DelayMode | undefined {
      const msg = this.scheduleRule && this.scheduleRule.scheduleMsg;
      if(msg && msg.WxTpl) {
        return DelayMode.UseTpl;
      } else if (msg){
        return DelayMode.UseMsg;
      } else {
        return undefined;
      }

    },
    updateMsg(msg: ScheduleMsgDisplayInfo) {
      this.info = msg;
    },
    closeSelectEvent() {
      this.showSelectEvent = false;
    },
    eventTriggered(): EventTriggered {
      return this.scheduleRule.ruleContext.EventTriggered;
    },
    delay(): ScheduleDelay {
      return this.scheduleRule.ruleContext.EventTriggered.delay;
    },
    wxTpl(): WxTpl | null {
      if (this.scheduleRule.scheduleMsg) {
        return this.scheduleRule.scheduleMsg.WxTpl;
      } else {
        return null;
      }
    },
    wxTemplateId(): string | null {
      return this.wxTpl() ? this.wxTpl()!.templateId : null;
    },
    scheduleMsg(): ScheduleMsg | undefined {
      return this.scheduleRule.scheduleMsg;
    },
    hasSetEvent(): boolean {
      return (
        this.scheduleRule.ruleContext.EventTriggered.eventType !== undefined
      );
    },
    hasSetDelay(): boolean {
      return this.scheduleRule.ruleContext.EventTriggered.delay !== undefined;
    },
    hasSetMsg(): boolean {
      const msg = this.scheduleRule && this.scheduleRule.scheduleMsg;
      switch((this as any).eventDelayMode) {
        case DelayMode.UseTpl:
          return msg && msg.WxTpl !== undefined;
        case DelayMode.UseMsg:
          return msg && !msg.WxTpl;
      }
    },
    confirmCreate() {
      const queries = {};
      if (this.validateCreate()) {
        this.creating = true;
        if (this.scheduleRule.scheduleMsg.WxTpl) {
          const keys = Object.keys(this.scheduleRule.scheduleMsg.WxTpl.params);
          keys.forEach(i => {
            this.scheduleRule.scheduleMsg.WxTpl.params[i].value = transDiv(
              transValue(
                this.tranProps,
                this.scheduleRule.scheduleMsg.WxTpl.params[i].value
              )
            );
          });
        }
        const queries = {
          ruleName: this.scheduleRule.ruleName!,
          ruleType: ScheduleRuleType.Event,
          ruleContext: this.scheduleRule.ruleContext,
          scheduleMsg: this.scheduleRule.scheduleMsg!,
        };
        if (this.scheduleRule.id) {
          (queries as any)['id'] = this.scheduleRule.id;
          ruleClient
            .updateRule(queries)
            .success(r => {
              this.$Message.success('修改成功');
              setTimeout(() => {
                this.$emit('success');
              }, 100);
            })
            .failure((code: string, msg?: string) => {
              this.$Message.error(msg);
              this.creating = false;
            })
            .error(e => {
              this.$Message.error(e.toString());
              this.creating = false;
            });
        } else {
          ruleClient
            .createRule(queries)
            .success(r => {
              this.$Message.success('创建成功');
              setTimeout(() => {
                this.$emit('success');
              }, 100);
            })
            .failure((code: string, msg?: string) => {
              this.$Message.error(msg);
              this.creating = false;
            })
            .error(e => {
              this.$Message.error(e.toString());
              this.creating = false;
            });
        }
      }
    },
    updateScheduleRuleName(event: Event) {
      this.$store.commit(
        'UPDATE_SCHEDULE_RULE_NAME',
        (event.target as any)['value']
      );
    },
    validateCreate() {
      if (
        !this.scheduleRule.ruleName ||
        (this.scheduleRule.ruleName! as string).trim() === ''
      ) {
        this.$Message.warning('请设置规则名称');
        return false;
      } else if (
        this.showSelectEvent ||
        this.scheduleRule.ruleContext.EventTriggered.eventType === undefined
      ) {
        this.$Message.warning('请设置触发事件');
        return false;
      } else if (
        this.showPrepareTime ||
        this.scheduleRule.ruleContext.EventTriggered.delay === undefined
      ) {
        this.$Message.warning('请设置等待时间');
        return false;
      } else if (
        this.showScheduleMsg ||
        this.scheduleRule.scheduleMsg === undefined
      ) {
        this.$Message.warning('请设置推送消息');
        return false;
      } else {
        return true;
      }
    },
    traceDisplay(type: number): string {
      const traceType = TraceEventType.find(tpe => tpe.value === type);
      return traceType ? traceType!.title : '';
    },
  },
});
